import { Injectable } from '@angular/core';
import { Authentication } from '../models/Authentication';
import { environment } from '../../environments/environment';
import { throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TestService {
  headers = new HttpHeaders();

  constructor(private readonly http: HttpClient) { }


  getTests() {
    return this.http.get<Authentication>(environment.url + '/Test/StartTest',
      {})
      .pipe(
        tap((t) => sessionStorage.setItem('testValue', JSON.stringify(t))),
        catchError(this.errorHandl)
      );
  }

  postTest(data: any) {
    return this.http.post<any>(environment.url +
      '/Test/SetDataTest', data, { headers: this.headers.set('Authorization', sessionStorage.getItem('t')) })
      .pipe(catchError(this.errorHandl));
  }

  /**
   * Control errores generico para todas las llamadas
   * @param error: Object
   */
   errorHandl(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.error(errorMessage);
    return throwError(errorMessage);
  }
}
